<template>
    <div class="animated fadeIn">
        <b-row v-if="reservation == null">
                        <b-col>
                            <b-form-group label="" label-for="isnonsatsangi">
                                <b-form-checkbox size="lg" v-model="isnonsatsangi"
                                    @change="toggleForm" id="isnonsatsangi" name="isnonsatsangi"
                                     switch>
                                    <b>Is Visitor Not Satsangi? </b>
                                </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>              
        <b-card no-body v-if="!isnonsatsangi">
            <b-card-body fluid="xl">
                <b-card-title class="text-center mb-2">
                    <h2>Satsangi Visitor Entry</h2>
                </b-card-title> 
             
                <b-overlay :show="loading" rounded="sm">              
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Visitor Id Number"
                                label-for="idNumber">
                                <b-form-input id="idNumber" name="idNumber"
                                    v-model.lazy.trim="idNumber" autofocus  
                                    @keydown.native="handleEnterKey" @blur="handleEnterKey" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label="Number of visitors" label-for="numberMembers" label-class="font-weight-bold" >
                                <b-input-group>
                                <b-input-group-prepend>
                                    <b-button variant="outline-info" @click="removeMember">Remove Visitor</b-button>
                                </b-input-group-prepend>
                                <b-form-input v-model="numberOfMembers" disabled></b-form-input>
                                <b-input-group-append>
                                    <b-button variant="success" @click="addMember">Add Visitor</b-button>
                                </b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <gate-member-list ref="memberList"></gate-member-list>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="No of Children" label-for="people">
                                <b-form-spinbutton id="people" v-model="$v.form.$model.children" min=0 max=10000
                                    inline></b-form-spinbutton>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="No of Adults" label-for="people">
                                <b-form-spinbutton id="adults" v-model="$v.form.$model.adults" min=0 max=10000
                                    inline></b-form-spinbutton>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Arrival Date" label-for="fromdate">
                                <b-form-datepicker id="fromdate" name="fromdate" :min="form.todate ? form.todate : min"
                                    :initial-date="min" :state="validateState('fromdate')"
                                    v-model.trim="$v.form.fromdate.$model" aria-describedby="liveFeedbackFromDate"
                                    placeholder="DD/MM/YYYY" today-button reset-button close-button autofocus
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />

                            </b-form-group>
                            <b-form-invalid-feedback id="liveFeedbackFromDate">Please enter From
                                Date</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Departure Date" label-for="todate">
                                <b-form-datepicker id="todate" name="todate" :min="form.fromdate ? form.fromdate : min"
                                    :state="validateState('fromdate')" v-model.trim="$v.form.todate.$model"
                                    aria-describedby="liveFeedbackToDate" placeholder="DD/MM/YYYY" today-button
                                    reset-button close-button autofocus
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />

                            </b-form-group>
                            <b-form-invalid-feedback id="liveFeedbackTiDate">Please enter To
                                Date</b-form-invalid-feedback>
                        </b-col>
                        <b-col>
                            <b-form-group label-class="font-weight-bold" label="Departure Time" label-for="toTime">
                                <b-input-group class="mb-3">
                                    <b-form-input id="toTime-input" v-model="$v.form.toTime.$model" type="text"
                                        placeholder="HH:mm"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-timepicker id="toTime" name="toTime" v-model="$v.form.toTime.$model"
                                            button-only right locale="en" :state="validateState('toTime')"
                                            aria-describedby="liveFeedbackToTime" now-button reset-button
                                            aria-controls="toTime-input"></b-form-timepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback id="liveFeedbackToTime">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>     
                    </b-overlay>            
                    <b-row>
                        <b-col>
                            <b-button ref="submitButton" type="submit"  @click="onSubmit" variant="primary" :disabled="$v.form.$invalid">
                                Save
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button class="ml-1" type="reset" @click="onReset">Reset</b-button>
                        </b-col>
                        <b-col>
                            <b-button class="ml-1"  @click="stopLoading">Stop Loading</b-button>
                        </b-col>
                    </b-row>
               
            </b-card-body>
            
        </b-card>
        <non-satsangi-entry v-if="isnonsatsangi"  @success="newEntrySuccess" @cancel="newEntrySuccess"  />

    </div>
</template>
<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import {
    mapState,
    mapActions
} from 'vuex'
import GateMemberList from './GateMemberList'
import NonSatsangiEntry from './NonSatsangiEntry'


import { validationMixin } from "vuelidate";
import { required, requiredIf, minLength, numeric, minValue, maxLength, email, alpha, helpers } from "vuelidate/lib/validators";

import XmlToJson from '../samadh/xmlToJson.js'

const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)
const formShape = {    
    fromdate: null,
    todate: null,
    toTime: null,
    children: 0, 
    members: null,
    adults: 0,
    excludemeal: false

}
export default {
    mixins: [validationMixin],
    name: "GateVistorEntry",
    props: {
        reservation: Object
    },
    components: {   
        GateMemberList,
        NonSatsangiEntry
    },
    data() {
        return {
            form: Object.assign({}, formShape),
            min: new Date(),
            submitted: false,
            showHouses: false,
            idNumber: null,
            numberOfMembers: 0,
            loading: false,
            isnonsatsangi: false 
        }
    },  
    validations: {
        form: {                        
            fromdate: { required },
            todate: { required },
            toTime: { required },
            children: { required },
            members: {
        required,
        $each: {
          name: {
            required,
          },
          age: {            
          },
          i_card_number: {
            required
          },
          phone: {            
          }
        }
      }
        }
    },
    methods: {         
        newEntrySuccess(){
    //  this.$refs.modalAadharCard.hide();
      this.isnonsatsangi = false;
  },
        toggleForm(){
            console.log(this.isnonsatsangi)
            this.form = Object.assign({}, formShape)
            this.form.fromdate = this.formatDate(new Date())
            this.idNumber = null;
            this.numberOfMembers = 0;
            this.loading = false;
        },
        stopLoading(){
            this.loading = false;
        },
        onSubmit() {
            if (this.submitted == false) {
                let returnValue = this.compareDates(this.form.fromdate, this.form.todate);              
                if (returnValue == false) {
                    this.showErrorMsg({
                        message: "Departure date must be after the arrival date"
                    })
                    return;
                }
                this.submitted = true;
                let params = {
                    id_card_no: this.form.idNumber,
                    adharid: this.form.adharid,
                    visitorname: this.form.visitorname,
                    mobileNumber: this.form.mobileNumber,
                    buildingName: this.form.buildingName,
                    fromdate: this.form.fromdate,
                    todate: this.form.todate,
                    departure_time: this.form.toTime,
                    people: this.form.people,
                    houseNo: this.form.houseNo,
                    isnonsatsangi: this.isnonsatsangi

                };
                Vue.axios.post("/admin/createEntry", params)
                    .then(response => {
                        console.log(response);
                        if (response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                        }
                        else if (typeof response.data !== "undefined" && response.data.success == true) {
                            this.showSuccessMsg({ message: "Entry created successfully." });
                            this.onReset()
                        } else {
                            if (response.data != null && response.data.success == false) {
                                this.showErrorMsg({ message: response.data.message });
                              
                            }
                            else {
                                this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                            }

                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 400 || error.response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                        } else {
                            this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                        }
                    })
                console.log(this.form);
                this.submitted = false;
            }
        },
    
        getMembersCount(){
        return this.$refs.memberList.getMembersCount()
      },
      transform(xml) {
    var parser = new XmlToJson();
    var json = parser.parse(xml);
    return json;
  },
  reverseString(str) {

    var splitString = str.split(""); 
    
    var reverseArray = splitString.reverse(); 
    
 
   
    var joinArray = reverseArray.join(""); 
    
   
    return joinArray; 
},

  processScannedCard(qrCode){
    var scannedQrCode = qrCode;
    console.log(scannedQrCode);
    var cardInfo =this.transform(scannedQrCode);


    if(Object.keys(cardInfo).length > 0 ){
      
        return  {
            id_card_no: cardInfo.PrintLetterBarcodeData.uid,
            main_name:  cardInfo.PrintLetterBarcodeData.name,
                gender:  cardInfo.PrintLetterBarcodeData.gender,
                yob: cardInfo.PrintLetterBarcodeData.yob,
                gname:  cardInfo.PrintLetterBarcodeData.gname,
                co:  cardInfo.PrintLetterBarcodeData.co,
                loc:  cardInfo.PrintLetterBarcodeData.loc,
                city:  cardInfo.PrintLetterBarcodeData.vtc,
                po:  cardInfo.PrintLetterBarcodeData.po,
                dist:  cardInfo.PrintLetterBarcodeData.dist,
                subdist:  cardInfo.PrintLetterBarcodeData.subdist,
                state:  cardInfo.PrintLetterBarcodeData.state,
                pc:  cardInfo.PrintLetterBarcodeData.pc,
                dob:  cardInfo.PrintLetterBarcodeData.dob != null && cardInfo.PrintLetterBarcodeData.dob.trim().length > 0 ? cardInfo.PrintLetterBarcodeData.dob.replaceAll("/", '-').split("-").reverse().join("-") : null
        };
    }
    else{
        return null;
    }
},

        handleEnterKey(event) {            
            if((event.which == 13) && this.idNumber != null && this.idNumber.length > 0 && this.idNumber.startsWith('<?xml')){
                this.loading = false;
                let scannedCardData = this.processScannedCard(this.idNumber);
                if(scannedCardData != null){
                    let item = _.clone(scannedCardData);                            
                            this.$refs.memberList.setMember(item);
                            this.numberOfMembers = this.getMembersCount()
                            this.form.members = this.$refs.memberList.getMembers()
                            this.idNumber = null;
                            this.form.adults = this.form.adults + 1;

                }
                else{
                    this.showErrorMsg({ message: "No satsangi/visitor data found for scanned Aadhar Card. Please contact administrator." });                    
                }

            }
            else if ((event.which == 13) && this.idNumber != null && this.idNumber.length > 0) {
                this.loading = false;
                let params = { id_card_no: this.idNumber };
                Vue.axios.post("/validateSatsangi", params)
                    .then(response => {
                        console.log(response);
                        if (typeof response.data !== "undefined" && response.data.success == true && response.data.customer != null) {
                            let item = _.clone(response.data.customer[0]);                            
                            this.$refs.memberList.setMember(item);
                            this.numberOfMembers = this.getMembersCount()
                            this.form.members = this.$refs.memberList.getMembers()
                            this.idNumber = null;
                            this.form.adults = this.form.adults + 1;
                        } else {
                            if (response.data != null && response.data.success == false) {
                                this.showErrorMsg({ message: response.data.error });
                            }
                            else {
                                this.showErrorMsg({ message: "Satsangi Not foud with entered Satsangi Id Number. Please enter data manually." });
                            }

                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 400 || error.response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.error
                            });
                        } else {
                            this.showErrorMsg();
                        }
                    })
            }
            else{
                if(this.idNumber != null && this.idNumber.length > 15){
                    this.loading = true;          
                }
                
            
            }

        },
        addMember() {
            if (this.numberOfMembers < 500) {               
                this.$refs.memberList.addMember()
                this.numberOfMembers = this.getMembersCount();
                this.form.adults = this.form.adults + 1;
            }
        },
        removeMember() {
            if (this.numberOfMembers > 0) {                
                this.$refs.memberList.removeMember()
                this.numberOfMembers = this.getMembersCount();
                this.form.adults = this.form.adults - 1;
            }
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        onReset() {
            // Reset validation
            this.form = Object.assign({}, formShape);          
            this.$refs.memberList.onReset()
            this.numberOfMembers = this.getMembersCount();
            this.idNumber = null;
            this.loading = false;
            this.submitted = false;
            this.form.adults = 0;
            this.$nextTick(() => {
                this.$v.$reset()
            })
            this.form.fromdate = this.formatDate(new Date())
        },
        onSubmit() {
            if (this.submitted == false) {
                let returnValue = this.compareDates(this.form.fromdate, this.form.todate);
                console.log(returnValue);
                if (returnValue == false) {
                    this.showErrorMsg({
                        message: "Departure date must be after the arrival date"
                    })
                    return;
                }
                this.submitted = true;
                let totalPeople = this.form.children + this.form.adults;                
                let params = {
                    
                    fromdate: this.form.fromdate,
                    todate: this.form.todate,
                    departure_time: this.form.toTime,
                    people: totalPeople,
                    children: this.form.children,
                    adults: this.form.adults,
                    members: this.$refs.memberList.getMembers(),
                    isnonsatsangi: this.isnonsatsangi

                };
                Vue.axios.post("/admin/createGateVisitorEntry", params)
                    .then(response => {
                        console.log(response);
                        if (response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                        }
                        else if (typeof response.data !== "undefined" && response.data.success == true) {
                            this.showSuccessMsg({ message: "Entry created successfully." });
                            this.onReset()
                            if(this.reservation != null){
                                this.$emit('success', this.reservation);
                            }
                        } else {
                            if (response.data != null && response.data.success == false) {
                                this.showErrorMsg({ message: response.data.message });
                              
                            }
                            else {
                                this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                            }

                        }
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status == 400 || error.response.status == 422) {
                            this.showErrorMsg({
                                message: error.response.data.message
                            });
                        } else {
                            this.showErrorMsg({ message: "Something went wrong. Please contact administrator." });
                        }
                    })
                console.log(this.form);
                this.submitted = false;
            }
        }
    },
    mounted() {     
      
        if(this.reservation != null && this.reservation.hasOwnProperty('members')){
           
            var arrayLength = this.reservation.members.length;
                for (var i = 0; i < arrayLength; i++) {
                 
                    let member = this.reservation.members[i];
                    if(i == 0){
                        member['phone'] = this.reservation.phone;
                    }
                   this.$refs.memberList.setReservationMembers(member)
                    this.form.adults = this.form.adults + 1;
                    
                   
                    //Do something
                }
         
            this.form.fromdate = this.reservation.arrival_date;
            this.form.todate = this.reservation.departure_date;
            this.form.toTime = this.reservation.departure_time;
            this.form.members = this.$refs.memberList.getMembers()
            
        }
        this.numberOfMembers = this.getMembersCount(); 


    },
    created() {
        this.form.fromdate = this.formatDate(new Date())
    }


}
</script>

<style>
.wait-cursor {
  cursor: wait;
}
</style>